module.exports = __webpack_public_path__ + "fonts/Lato-Hairline.4b5df23b.woff2";